module.exports = __webpack_public_path__ + "static/media/ieeevis-18.7abd8f20.jpg";